// @flow weak

import PropTypes from 'prop-types';
import React from 'react';
import createReactClass from 'create-react-class'; // eslint-disable-line no-restricted-syntax

import { DropdownMenuWrapper } from 'app/common/components/DropdownMenu';

const DropdownStateful = createReactClass({
  displayName: 'DropdownStateful',

  propTypes: {
    items: PropTypes.array,
    renderMenu: PropTypes.func.isRequired,
    renderToggle: PropTypes.func.isRequired,
    onChoose: PropTypes.func,
    onOpen: PropTypes.func,
    onClose: PropTypes.func,
  },

  getInitialState() {
    return { isOpen: false };
  },

  close() {
    if (this.props.onClose) {
      this.props.onClose();
    }
    this.setState({ isOpen: false });
  },

  onChoose(value, didConfirm, item) {
    if (didConfirm && !item.shouldKeepDropdownOpen) {
      this.close();
    }
    if (this.props.onChoose) {
      this.props.onChoose(value, didConfirm, item);
    }
  },

  onClickToggler(event: SyntheticEvent<*>) {
    if (!this.state.isOpen && this.props.onOpen) {
      this.props.onOpen(event);
    }
    this.setState({ isOpen: !this.state.isOpen });
  },

  onClickOutside() {
    this.close();
  },

  render() {
    const { props } = this;
    const menu = !this.state.isOpen
      ? null
      : props.renderMenu({
          items: this.props.items,
          onChoose: this.onChoose,
          onClickOutside: this.onClickOutside,
        });
    const toggle = props.renderToggle({
      onClick: this.onClickToggler,
    });
    return (
      <DropdownMenuWrapper {...this.props}>
        {toggle}
        {menu}
      </DropdownMenuWrapper>
    );
  },
});

export default DropdownStateful;
